import { render, staticRenderFns } from "./Clothing.vue?vue&type=template&id=496cb2d7&"
import script from "./Clothing.vue?vue&type=script&lang=js&"
export * from "./Clothing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports